import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8804570a&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=8804570a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8804570a",
  null
  
)

component.options.__file = "App.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSpeedDial } from 'vuetify/lib'
installComponents(component, {
  VApp,
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VCarousel,
  VCarouselItem,
  VDialog,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VListTileAction,
  VListTileContent,
  VListTileTitle,
  VProgressCircular,
  VSpacer,
  VSpeedDial,
})
